import Link from 'next/link';
import { useRouter } from 'next/router';

import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { STUDENTS_CASES } from '@/widgets/layouts/main/students-cases/constants/cases-list';

import { Article } from '@/shared/components/article';
import { TextGradient } from '@/shared/components/text-gradient';
import { Button } from '@/shared/components/ui/button';
import { PageSeo } from '@/shared/lib/seo';

import { Case } from './components/case-info';
import { Main } from './components/main';

export const SpecificCasePage = () => {
  const router = useRouter();
  const pagePath = router.asPath;
  const studentCase = STUDENTS_CASES.find((studentCase) => studentCase.href === pagePath);

  return (
    <>
      <PageSeo
        title={`Кейс - ${studentCase?.name}`}
        description={`Кейс нашего ученика (${studentCase?.name}). История о том, как английский помог нашему ученику достичь своих целей!  Anglichannka – деловой английский для работы.`}
      />

      {studentCase && (
        <>
          <Main studentCase={studentCase} />

          <div className="overflow-hidden">
            <Case studentCaseInfo={studentCase.info} studentName={studentCase.name} />

            <CallToAction header="Хотите так же?" withForm />
          </div>
        </>
      )}

      {!studentCase && (
        <Article tag="main">
          <div className="flex flex-col place-items-center">
            <TextGradient
              className="mb-2 text-center text-3xl xs:text-5xl sm:mb-6 md:text-6xl"
              tag="h1"
              text="Такого кейса не существует"
            />

            <Link href="/cases" aria-label="Читать кейсы">
              <Button aria-label="Читать кейсы">Читать кейсы</Button>
            </Link>
          </div>
        </Article>
      )}
    </>
  );
};

SpecificCasePage.Layout = MainLayout;
